import gql from "graphql-tag";

export const POST_RESOURCE_VITALS = gql`
  mutation post_resource_vitals($input: ResourceVitalsInput!) {
    postResourceVitals(input: $input)
  }
`;
